import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../core/animations';
import { User } from '../../../../core/modelos/user';
import { UsuariosService } from '../usuarios.service';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';
import { ActivosOcultosService } from '../../../../core/services/activos-ocultos.service';
import { ActivoOculto } from '../../../../core/modelos/activo_oculto';

@Component({
    selector: 'fuse-usuarios-detalle',
    templateUrl: './usuarios-detalle.component.html',
    styleUrls: ['./usuarios-detalle.component.scss'],
    animations   : fuseAnimations
})
export class UsuariosDetalleComponent implements OnInit {

    usuario: User;
    idUsuario: number;
    activosOcultos: Array<ActivoOculto>;
    activosOcultosSelected: Array<ActivoOculto>;

    formulario: FormGroup;

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private usuariosService: UsuariosService,
        private router: Router,
        private activosOcultosService: ActivosOcultosService,
        private notificaciones: NotificacionesService
    ) {
        // Traigo el cliente por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idUsuario = params['idUsuario'];
        });
    }

    ngOnInit() {

        this.getUsuarios();
        this.getActivosOcultos(this.idUsuario);

    }

    getUsuarios() {

        this.usuariosService.getUsuario(this.idUsuario).subscribe(
            data => {
                if (data.success) {
                    this.usuario = data.items;
                    this.crearFormulario();

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOObtenido);
                    this.router.navigate(['usuarios']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
                this.router.navigate(['usuarios']);
            }
        );

    }

    getActivosOcultos(id) {

        this.activosOcultosService.getActivosOcultos(id).subscribe(
            data => {
                if (data.success) {
                    this.activosOcultos = data.items;
                    this.activosOcultosSelected = this.activosOcultos.filter(d => d.hidden)
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.ActivosOcultos.SinActivos);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    crearFormulario() {

        this.formulario = this.fb.group({

            'nombre' :          new FormControl({value: this.usuario.nombre, disabled: true}),
            'apellidos':        new FormControl({value: this.usuario.apellidos, disabled: true}),
            'email':            new FormControl({value: this.usuario.email, disabled: true}),
            'cliente':          new FormControl({value: this.usuario.cliente ? this.usuario.cliente.nombre : '-', disabled: true}),
            'activosOcultos':   new FormControl({value: this.activosOcultos, disabled: true}),
            // Faltan cosas como rol, activos o funcionalidades
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/usuarios/detalle/usuarios-detalle.component.ts